$(document).on("click", ".question_product,.faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});



$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});


$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#benifits']", function (e) {
  e.preventDefault();
  document.querySelector('#benifits').scrollIntoView({
    behavior: 'smooth'
  })
});




jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 1000,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });

});



$(document).on("click", ".option_item.option_item_last_full", function (e) {
  setTimeout(function () {
var active_index = $('.free_gifts_item.active').index();
document.querySelector('select.kaching-bundles__bar-variant-select.kaching-bundles-option').selectedIndex = active_index;

const select = document.querySelector('select.kaching-bundles__bar-variant-select.kaching-bundles-option');
const changeEvent = new CustomEvent('change', {
bubbles: true,
cancelable: true,
composed: true,
detail: {
value: select.value,
source: 'programmatic',
},
});
select.dispatchEvent(changeEvent);
}, 500);
});



$(document).on("click", ".free_gifts_item", function (e) {
  e.preventDefault();
$('.free_gifts_item').removeClass('active');
$(this).addClass('active');
var active_index = $('.free_gifts_item.active').index();
document.querySelector('select.kaching-bundles__bar-variant-select.kaching-bundles-option').selectedIndex = active_index;

const select = document.querySelector('select.kaching-bundles__bar-variant-select.kaching-bundles-option');
const changeEvent = new CustomEvent('change', {
bubbles: true,
cancelable: true,
composed: true,
detail: {
value: select.value,
source: 'programmatic',
},
});
select.dispatchEvent(changeEvent);
});
